import React, { useState, useContext, useEffect, useRef } from 'react'
import myContext from '../../FiltersComponent/context/context'
import { removeSpecialCharacters, removeWhiteSpace, getTargetMarketPayload, isFilterApplied, distanceFromSubject, getQueryStringValue } from '../../Utility/Utility.js'
import GetSearchResult from '../../Utility/GetSearchResult/GetSearchResult'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import { fetchPropertySuggestion, fetchPropertySearchResult } from '../../Services/propertySearchService'
import { Apartment, Room } from '@material-ui/icons'

const GetPropertySuggestion = () => {

  const { preSearchCriteria, searchCriteria, setSearchCriteria, setSearchResult, setShowSpinner, searchFields, setSearchFields, savedSearch } = useContext(myContext)
  const [show, setShow] = useState(false)
  const [showSuggestionSpinner, setShowSuggestionSpinner] = useState(false)
  const [propertySuggestions, setPropertySuggestions] = useState([])
  const [inputVal, setInputVal] = useState('')
  const inputName = useRef(null)
  const [targetMarket, setTargetMarket] = useState()

  useEffect(
    () => {
      if (inputVal.length >= 3) {
        inputChanged()
      }
    },
    [inputVal]
  )

  useEffect(
    () => {
      if (getQueryStringValue('propId') && getQueryStringValue('propId') !== null) {
        searchForRelatedProperty()
      }
    },
    [getQueryStringValue('propId')]
  )

  useEffect(
    () => {
      if (inputVal.length === 0 && inputName && inputName.current) {
        inputName.current.focus()
      }
    },
    [preSearchCriteria]
  )

  useEffect(
    () => {
      if (preSearchCriteria.isSearchTargetMarket) {
        setTargetMarket(getTargetMarketPayload(savedSearch))
      }
    },
    [savedSearch, preSearchCriteria]
  )

  async function searchForRelatedProperty() {

    let payload = JSON.stringify({
      "subProperty": {
        "id": getQueryStringValue('propId'),
        "distance": 0.1
      }
    })
    setShowSpinner(true)

    const response = await fetchPropertySearchResult(payload)

    if (response.data && response.data.data) {
      let data = response.data.data
      setShowSpinner(false)
      if (data.length > 0) {
        let property = data.filter(x => x.omniViewPropertyId === getQueryStringValue('propId'))[0]
        handleClick(property)
      }
    }


  }

  async function fetchSuggestion(payLoad) {

    const response = await fetchPropertySuggestion(payLoad)

    setShowSuggestionSpinner(false)
    if (response && response.status === 200) {
      if (response.data && response.data.data) {
        // console.log('response:::', response.data.data)
        setPropertySuggestions(response.data.data)
        setShow(true)
      }
    }

  }

  function isShowSuggestions(onFocus) {
    let newShow = false
    if (propertySuggestions.length > 0 && onFocus) {
      newShow = true
    }

    setShow(newShow)
  }

  async function handleKeyDown(e) {
    if (e.key === "Escape") {
      setShow(false)
    }
  }

  async function handleKeyPress(e) {
    let { value } = e.target

    if (e.key === 'Enter' || e.keyCode === 13) {

      if (value.length > 0) {

        const newSearchCriteria = { ...searchCriteria }
        // newSearchCriteria.property.propertyName = value

        newSearchCriteria.property = {
          propertyName: value,
          // if prior name is checked, search for prior name as well
          ...(preSearchCriteria.isPriorName && { priorName: true })
        }

        newSearchCriteria.subjectProperty = {}
        newSearchCriteria.distanceFields = []
        newSearchCriteria.pagination.from = 0

        setSearchCriteria({ ...newSearchCriteria })

        setSearchResult({ property: [], totalCount: 0 })

        setShowSpinner(true)
        setShow(false)

        const searchResult = new GetSearchResult(newSearchCriteria, function () { })
        const response = await searchResult.fetchWildSearchResult()
        setShowSpinner(false)
        loadData(response, newSearchCriteria)
      }

    }

  }

  function loadData(response, newSearchCriteria) {
    try {
      if (response.data && response.data.data) {
        let data = response.data.data
        if (newSearchCriteria.subjectProperty && newSearchCriteria.subjectProperty.propertyName) {
          data = distanceFromSubject(data, newSearchCriteria)
        }
        // checkLocationTypes(data)
        setSearchResult({ property: data, totalCount: response.data.total })
      }
    } catch (err) {
      console.log('error in loadData :: ', err)
    }
  }

  function inputChanged() {
    let suggestionCriteria = {}
    let payLoad = ''
    // let targetMarketPayload = ''
    let newInputValue = inputVal

    setShow(true)

    newInputValue = removeSpecialCharacters(newInputValue)
    newInputValue = removeWhiteSpace(newInputValue)

    if (newInputValue.length >= 2) {

      if (newInputValue.length > 3) {
        setShowSuggestionSpinner(true)
      }

      suggestionCriteria = {
        propertyName: newInputValue,
        separateAddress: true,
        // if prior name is checked, search for prior name as well
        ...(preSearchCriteria.isPriorName && { priorName: true })
      }

      payLoad = { suggestion: suggestionCriteria }

      if (preSearchCriteria.isSearchTargetMarket && targetMarket) {
        suggestionCriteria.targetMarket = targetMarket
      }

      fetchSuggestion(JSON.stringify(payLoad))

    }
  }

  function handleChange(e) {
    let { value } = e.target
    setInputVal(value)
  }

  function getAddress(property) {
    let address = ''

    address = `${property.addressLine1 ? property.addressLine1 : ''}, ${property.city ? property.city : ''}, ${property.state ? property.state : ''}  ${property.zipCode ? property.zipCode : ''}`
    address = address.replace(',,', ',')
    address = address.replace(', ,', ',')

    return address
  }

  function getName(property) {
    let name = ''
    try {
      name = `${property.propertyName}`

      if (preSearchCriteria.isPriorName && property.priorName) {
        name += ` | (${property.priorName})`
      }

      name = highlightText(name)

    } catch (e) {
      console.log(e)
    }

    return name
  }

  function highlightText(inputString) {
    let textToHighlight = inputVal.toLowerCase()
    textToHighlight = removeWhiteSpace(textToHighlight)

    inputString = inputString.toLowerCase()
    let splitInput = inputString.split(textToHighlight)

    return (
      <>
        <span className="capitalize">
          {splitInput.map((value, index) => (
            <>
              {index + 1 >= splitInput.length ?
                value
                : <span>{value}<b>{textToHighlight}</b></span>}
            </>
          ))
          }
        </span>
      </>
    )
  }

  const handleClick = async property => {
    if (property && property.omniViewPropertyId && property.propertyName) {
      let propertyInfoCacheObj = localStorage.getItem('propertyInfo') ? JSON.parse(localStorage.getItem('propertyInfo')) : {}
      propertyInfoCacheObj[property.omniViewPropertyId.substring(0, property.omniViewPropertyId.length - 3)] = property.propertyName;
      localStorage.setItem('propertyInfo', JSON.stringify(propertyInfoCacheObj));
    }
    setShow(false)
    setShowSpinner(true)
    setInputVal('')
    // setIsSubjectSelected(true)
    setPropertySuggestions([])

    checkPropertyType(property)

    const newSearchCriteria = { ...searchCriteria }
    newSearchCriteria.subjectProperty = property
    newSearchCriteria.distanceFields = []
    newSearchCriteria.prospecting = []
    newSearchCriteria.distanceFields.push(searchFields.distanceFields[0])
    newSearchCriteria.pagination.from = 0
    newSearchCriteria.sort = { "byMiles": { "propertyLocation": property.propertyLocation, "order": "asc" } }
    newSearchCriteria.polygon = { points: [] }
    setSearchCriteria({ ...newSearchCriteria })

    // setSearchCriteria((state) => {
    //   return state
    // })

    setSearchResult({ property: [], totalCount: 0 })

    const searchResult = new GetSearchResult(newSearchCriteria, function () { })
    const response = await searchResult.fetchSearchResult()
    setShowSpinner(false)
    setShow(false)
    // console.log('response:::', response)
    loadData(response, newSearchCriteria)
  }

  const clearPropertytype = () => {

    const newSearchFields = { ...searchFields }
    const newSearchCriteria = { ...searchCriteria }

    newSearchCriteria.propertyTypeFields = []
    newSearchFields.propertyTypeFields.map(x => {
      x.isChecked = false
      if (x.subtype === 'all') {
        x.show = false
        x.arrow = 'rotate(180)'
      }

      return x
    })

    setSearchFields({ ...newSearchFields })
    setSearchCriteria({ ...newSearchCriteria })
  }

  const checkPropertyType = property => {

    clearPropertytype()
    // console.log('searchFields::', searchFields)
    const j = searchFields.propertyTypeFields.findIndex(x => x.propertytype === property.omniViewPropertyType && x.subtype === 'all')
    const lstPropertyTypes = searchFields.propertyTypeFields.filter(x => x.propertytype === property.omniViewPropertyType && (x.subtype === property.subType || x.subtype.toLowerCase().includes('other') || x.subtype.toLowerCase().includes('not specified')))

    const newSearchFields = { ...searchFields }
    const newSearchCriteria = { ...searchCriteria }

    newSearchFields.propertyTypeFields[j] = { ...newSearchFields.propertyTypeFields[j], arrow: 'rotate(0)', show: true }
    // newSearchFields.propertyTypeFields[j] = { ...newSearchFields.propertyTypeFields[j], show: true }

    lstPropertyTypes.forEach(propItem => {
      const i = newSearchFields.propertyTypeFields.findIndex(x => x.propertytype === property.omniViewPropertyType && x.subtype === propItem.subtype)
      newSearchFields.propertyTypeFields[i] = { ...newSearchFields.propertyTypeFields[i], isChecked: true }
      newSearchCriteria.propertyTypeFields.push(newSearchFields.propertyTypeFields[i])
    })

    setSearchFields({ ...newSearchFields })
    setSearchCriteria({ ...newSearchCriteria })
  }

  const clearSubject = async () => {
    clearPropertytype()
    const newSearchCriteria = { ...searchCriteria }
    newSearchCriteria.subjectProperty = {}
    newSearchCriteria.distanceFields = []
    newSearchCriteria.propertyTypeFields = []
    setSearchCriteria({ ...newSearchCriteria })
    // setIsSubjectSelected(false)
    if (isFilterApplied(newSearchCriteria)) {
      // const searchResult = new GetSearchResult(newSearchCriteria, loadData)
      // searchResult.fetchSearchResult()
      setShowSpinner(true)
      const searchResult = new GetSearchResult(newSearchCriteria, function () { })
      const response = await searchResult.fetchSearchResult()
      setShowSpinner(false)
      loadData(response, newSearchCriteria)
    } else {
      setSearchResult({ property: [], totalCount: 0 })
    }
  }


  const getSuggestionByCategory = byAdd => {
    if (byAdd) {
      return propertySuggestions.filter(x => x.isAddressResult)
    } else {
      return propertySuggestions.filter(x => !x.isAddressResult)
    }
  }
  // window.addEventListener('click', e => {
  //   if (document.getElementById('divSuggestionContainer') && !document.getElementById('divSuggestionContainer').contains(e.target)) {
  //     if (show) {
  //       setShow(false)
  //     }
  //   }
  // })

  // const suggestionProp = [{ name: 'property 1' }, { name: 'property 2' }]
  // setPropertySuggestions({ ...suggestionProp })

  return (
    <>
      <div id="divSuggestionContainer" onFocus={() => setShow(true)} onBlur={() => setTimeout(() => setShow(false), 500)} className="leading-xl relative flex w-full flex-wrap items-stretch w-auto">
        {!searchCriteria.subjectProperty.propertyName ?
          showSuggestionSpinner ?
            <span className="loader h-6 w-6 items-center justify-center text-center absolute" ></span>
            :
            <span className="z-10 h-full leading-snug font-normal absolute text-center text-gray-400 absolute bg-transparent rounded text-base items-center justify-center w-6">
              <svg className="w-5 h-5 fill-current text-gray-500 z-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /></svg>
            </span>
          : null}

        {!searchCriteria.subjectProperty.omniViewPropertyId ?
          <input ref={inputName} data-testid="test-input-Search-Subject" value={inputVal} onFocus={() => isShowSuggestions(true)} onKeyDown={handleKeyDown} onKeyPress={handleKeyPress} onChange={handleChange} className="w-full shadow appearance-none pl-7 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Search for Subject property"></input>
          :
          <div className="w-full text-left flex flex-row justify-between items-center px-2">
            <div className="flex flex-row text-1 truncate mr-2 space-x-2">
              <span className='font-semibold'>{getName(searchCriteria.subjectProperty)}</span>
              <span className="text-muted text-1">{getAddress(searchCriteria.subjectProperty)}</span>
            </div>
            <div data-testid="test-clear-subject" className="cursor-pointer" onClick={() => clearSubject()}>
              <ClearOutlinedIcon fontSize="small" />
            </div>
          </div>}

        {show &&
          <div data-testid="test-div-suggestion" className="w-full text-left h-3\/4 md:h-300 overflow-y-auto overflow-x-hidden border-b-1 border-base flex flex-col z-dropdown shadow-2 bg-white origin-top-right absolute mt-7 rounded-md shadow-lg">
            <div className="flex flex-col">
              <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${propertySuggestions.length ? '' : 'hidden'}`}>
                <span >
                  Suggestions by Name
                </span>
                <span > <Apartment /> </span>
              </div>
              <div>
                {getSuggestionByCategory(false).map((value, index) => (
                  <>
                    <div data-testid="test-div-property-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                      <div className="text-2">{getName(value)}</div>
                      <div className="text-muted text-1">
                        {getAddress(value)}
                      </div>
                    </div>
                  </>
                ))}
              </div>
              <div className={`sticky-top flex justify-between border-b-1 border-base px-4 py-3 bg-gray-15 text-primary ${propertySuggestions.length ? '' : 'hidden'}`}>
                <span>
                  Suggestions by Address
                </span>
                <span > <Room /> </span>
              </div>
              <div>
                {getSuggestionByCategory(true).map((value, index) => (
                  <>
                    <div data-testid="test-div-property-suggestion" onClick={() => handleClick(value)} role="menuitem" key={index} className="flex flex-col border-b-1 border-base px-4 py-3 cursor-pointer hover:bg-gray-15">
                      <div className="text-2">{getName(value)}</div>
                      <div className="text-muted text-1">
                        {getAddress(value)}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>

          </div>}
      </div>
    </>

  )
}

export default GetPropertySuggestion
